


var catalog = {
    data: function () {
      return {
        addProduct: {},
        sliderCount:0,
        activeSlide:0,
        isVisible:false,
        favoriteProducts:[],
        itemsFavorite:[]
      }
    },

    filters:{

        currency: function(value)
        {
            if (typeof value !== "number") {
                    return value;
                }
                var formatter = new Intl.NumberFormat('ru-Ru', {
                    style: 'currency',
                    currency: 'RUB',
                    maximumFractionDigits:0
                });
            
                return formatter.format(value);
        }
    },

    computed: {

        isMobile()
        {
            if(window.mobile)
            {
                return true;
            }
            else
            {
                return false;
            }
        },
    },

    beforeDestroy() {
        if (this.observer) {
          this.observer.disconnect(); // Останавливаем наблюдение при уничтожении компонента
        }
    },

    mounted() {

        if (this.$root === this) {

            this.initIntersectionObserver();
        }


        
    },

    methods: {

          // Инициализация Intersection Observer
    initIntersectionObserver() {
        const options = {
          root: null, // В качестве корня выступает окно браузера
          rootMargin: '1000px 0px',
          threshold: 0 // Триггер срабатывает при появлении 10% элемента
        };
  
        this.observer = new IntersectionObserver(this.handleIntersection, options);
        
        // Если передан селектор, то наблюдаем за указанным элементом
        let target = this.observeSelector
            ? document.querySelector(this.observeSelector)
            : this.$el; // Иначе наблюдаем за корневым элементом

        if (target) {
            this.observer.observe(target);
        }
      },
      // Обработка пересечения
      handleIntersection(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {

            this.isVisible = true;
            this.onVisible(entry.target); // Вызываем метод, когда элемент виден
            
            this.observer.unobserve(entry.target); // Останавливаем наблюдение после первого срабатывания
          }
        });
      },
      // Метод, который будет переопределяться в компонентах
      onVisible(target) {
        //console.log("Элемент попал в область видимости "+target);
        // Вызывайте здесь свои действия или переопределяйте этот метод в компонентах
      },
    

        openGalleryFull(images, activeSlide = 0)
        {
            bus.$emit('vuebox', {"images": images, "activeSlide": activeSlide});
        },
        
        getPath(img)
        {
            return this.path+"/images/"+img;
        },

        checkPrice(item)
        {
            if(item.PROPS.OFF_PRICE && item.PROPS.OFF_PRICE[0].VALUE == 1)
            {
                return false;
            }

            if(item.PROPS.PRICE)
            {
                if(parseInt(item.PROPS.PRICE[0].VALUE) > 0)
                {
                    return true;
                }
            }

            return false;
        },

        getSliderParams(ref, event)
        {
            //console.log(this.$refs);
            //console.log(ref);
          // let swiper = event.target.swiper;
           

           let swiper = event.detail[0];
           //console.log(swiper);
           this.sliderCount = swiper.slides.length;
           this.activeSlide = swiper.activeIndex;
            // console.log(this.sliderCount);
            // console.log(this.activeSlide);
           
        },
        

        addPage: function()
        {
            let vue = this;

            event.preventDefault();
            event.stopImmediatePropagation();

            this.nextPage = true;
            this.arResult.NAV.CURRENT_PAGE = this.arResult.NAV.CURRENT_PAGE+1;
            this.refreshData();
           
        },

        goPage(num){

            this.nextPage = true;
            this.arResult.NAV.CURRENT_PAGE = num;
            this.refreshData();
        },


        refreshData: function(){

            let vue = this;

            //console.log(this.smartFilterParams);

            let data = {search: this.search, 
                        order: [0],  
                        category: this.category, 
                        smartFilter:{}
                        }; // ключи объекта data соответствуют параметрам метода



            if(this.smartFilterParams)
            {
                for(let param in this.smartFilterParams)
                {
                    data.smartFilter[param] = this.smartFilterParams[param];
                }

            }

            let params =  { // Вызывается без постфикса Action
                mode: 'class',
                //navigation: {page: this.arResult.NAV.CURRENT_PAGE},
                data: data,
                signedParameters: this.signedParameters
            };

            let number_page = "1";

            if(vue.nextPage)
            {
                    smoothScroll($(this.$el), 500);
                    //console.log(this.$el);
            }
            // if(vue.nextPage)
            //         {
            //             $('html, body').animate({
            //                     scrollTop: $("#shops_vue_<?=$arParams["IBLOCK_ID"] ?>").offset().top - 200
            //                 }, 500);
            //         }
                    
            if(vue.nextPage || vue.firstLoad)
            {
                params.navigation = {page: this.arResult.NAV.CURRENT_PAGE};
                number_page = this.arResult.NAV.CURRENT_PAGE;
                vue.firstLoad = false;
                
            }

            vue.loading = true;

            let params_query = new URLSearchParams({
                    mode: "class",
                    nav: "page-"+number_page,
                    c: "vue:shops",
                    action:"filterShops"
            });

            data.signedParameters = this.signedParameters;
            //vue.arResult.ITEMS = [];

            $.ajax({
                type: "POST",
                url: "/bitrix/services/main/ajax.php?"+params_query.toString(),
                data: data,
                headers: {'x-bitrix-csrf-token': this.token,
                        'x-bitrix-site-id': this.siteId },
                //dataType: "dataType",
                success: function (response) {

                    if (response.status === 'success') {

                        if(vue.nextPage)
                        {
                            response.data.data = vue.prepareImages(response.data.data);

                            vue.arResult.ITEMS = response.data.data;

                            // response.data.data.forEach(element => {

                            //     vue.arResult.ITEMS.push(element);
                            // });
                            
                            vue.nextPage = false;
                        }
                        else
                        {
                            //vue.arResult.ITEMS = [];
                            vue.arResult.ITEMS = vue.prepareImages(response.data.data);
                        }

                        
                        vue.arResult["NAV"] = response.data.nav;
                        vue.arResult.PAGINATION = response.data.pagination;

                        vue.loading = false;

                    }
           
                }
            });



        },

        hello: function () {
          console.log('привет из примеси!')
        },
        
        sendRequest: function(params)
        {
          

        },

        prepareImages: function(items){

            if(!items)
            {
                return false;
            }

            let vue = this;

            items.forEach(function(param, i, arr){

                if(param.PREVIEW_PICTURE == null)
                {
                    param.PREVIEW_PICTURE = {};
                    param.PREVIEW_PICTURE.SRC = vue.componentPath+"/images/shop.png";
                }
            });

            return items;

        },

        

        addToBasket: function(item){

          let vue = this;
          let params = {entity: "product", 
                  action: "addProductBasket",
                  id_product: item.ID
              };

              $.ajax({
                type: "POST",
                url: "/local/ajaxHandler.php",
                data: params,
                dataType: "json",
                success: function (response) {
                    
                    if(response.status)
                    {
                        item.BASKET = true;
                        //console.log(vue);
                        vue.addProduct = item;
                        if ('addProductHandler' in vue)
                        {
                            vue.addProductHandler();
                        }
                        else
                        {
                            vue.$emit('add-product', item);
                        }

                        bus.$emit('add-product', 1);
                        window.BASKET_COUNT++;
                        
                    }
                }
            });
         

      },

      checkFavorite()
      {
        this.itemsFavorite = JSON.parse(getCookie('favorites') || '[]');
    
        if(this.arResult.ITEMS)
        {
            this.arResult.ITEMS.forEach(item => {

                this.checkFavoriteItem(item);
            
            });
        }
        else
        {
            this.checkFavoriteItem(this.arResult);
        }

      },

      checkFavoriteItem(item)
      {
        // Если товар есть в избранном, обновляем его статус
        if (this.itemsFavorite.find(favItem => favItem === item.ID)) {
            //item.FAVORITE = true;

            this.$set(item, 'FAVORITE', true);

        }
        else
        {
            this.$set(item, 'FAVORITE', false);
        }
      },

      toggleFavorite: function(item) {

        const MAX_FAVORITES = 10; // Максимальное количество товаров в избранном

        // Получаем текущие избранные товары из куки (если нет, то создаем пустой массив)
        let favorites = JSON.parse(getCookie('favorites') || '[]');
        console.log(favorites);

        // Проверяем, есть ли уже товар в избранном
        let index = favorites.findIndex(favItem => favItem === item.ID);
    
        if (index === -1) {
            // Если товара нет в избранном, проверяем лимит
            if (favorites.length >= MAX_FAVORITES) {
                // Если достигнут лимит, удаляем самый старый товар (первый в списке)
                let removedItem = favorites.shift(); // Удаляет первый элемент
                this.$set(removedItem, 'FAVORITE', false); // Обновляем его статус
    
                console.log("Товар удален из избранного, чтобы освободить место для нового");
            }
    
            // Добавляем новый товар в избранное
            favorites.push(item.ID);
    
            // Делаем свойство реактивным с помощью this.$set (Vue.set)
            this.$set(item, 'FAVORITE', true);
    
            console.log("Товар добавлен в избранное");
            bus.$emit('add-favorite', 1); // Эмитируем событие добавления (если требуется)
        } else {
            // Если товар уже есть в избранном, удаляем его
            favorites.splice(index, 1); // Удаляем элемент из массива
    
            // Делаем свойство реактивным и ставим его в false
            this.$set(item, 'FAVORITE', false);
    
            console.log("Товар удален из избранного");
            bus.$emit('remove-favorite', 1); // Эмитируем событие удаления (если требуется)
        }
    
        // Сохраняем обновленный массив в куки
        setCookie('favorites', favorites, { 'max-age': 3600 * 24 * 30 }); // Срок жизни куки - 30 дней
  

      },

      addProductCompare: function(item)
      {
          let params = {entity: "product", 
                  action: "addProductCompare",
                  id_product: item.ID
              };


          $.ajax({
              type: "POST",
              url: "/local/ajaxHandler.php",
              data: params,
              dataType: "json",
              success: function (response) {
                  
                  if(response.status)
                  {
                      item.COMPARE = true;
                      console.log("Добавлен");
                  }
              }
          });
        },

        getRating(star, item)
        {
            if(item.hasOwnProperty('RATING') && 
                star < parseInt(item.RATING) + 1)
            {
                return true;
            }
            else
            {
                return false;
            }
        },

        getCountFeed(item)
        {
            if(item.hasOwnProperty('BLOG_COMMENTS_CNT'))
            {
                return item.BLOG_COMMENTS_CNT;
            }
            else
            {
                return 0;
            }
        },
      }
  }

if(!window.mixins)
{
    window.mixins = {};
}

//window.mixins.catalog = catalog;
export default catalog;